<template>
  <div :class="hasTest()?'menu test-style':'menu'">
    <div class="menu-top flex-lm" @click="tohome">
      <img src="https://assets.pfotoo.com/wukong/logo.png" class="logo"/>
      <strong class="white-font font-size18">悟空投票</strong>
    </div>
    <div class="menu-list">
      <div class="menu-single flex-lm"
           @click="dialogVisible = true">
        <img src="https://assets.pfotoo.com/icon/%E5%8F%91%E8%B5%B7%E5%BE%81%E9%9B%86.svg" :style="{width:'auto',height:'auto',marginRight:20+'px'}"/>
        <h4 class="white-font font-size18">创建活动</h4>
      </div>
      <router-link v-for="(item,index) in menulist" :key="index" :to="{path:item.path}" tag="div" class="menu-single flex-lm" active-class = "_active" :style="{borderBottom:item.path=='upload' ? '1px solid #001a33' : '',}">
        <img :src="item.icon" :style="{width:item.width+'px',height:item.height+'px',marginRight:20+'px'}"/>
        <h4 class="white-font font-size18">{{item.name}}</h4>
      </router-link>
    </div>
    <el-dialog
            title="创建活动" class="fotoo"
            :visible.sync="dialogVisible"
            width="50%" append-to-body
            :before-close="handleClose">
      <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="手机端创建" name="wechat">
            <div class="block" style="text-align: center;">
              <el-image :src="codeurl">
                <div slot="placeholder" class="image-slot">
                  加载中<span class="dot">...</span>
                </div>
              </el-image>
              <div class="demonstration" style="margin-top: 20px;">使用微信，扫一扫</div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="电脑端创建" name="pc">
            <div class="block" style="text-align: center; padding: 150px 0;">
              <a href="https://mp.weixin.qq.com/s/bxscAgasuDrtHsfi88EGSA" target="_blank"
                 class="text-blue text-lg" style="text-decoration: none;color: #576B95;"
                 slot="reference">如何在电脑端创建活动、配置活动、参加活动、上传作品？</a>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import App from '../util/comfun'
  export default {
    name: 'menu',
    data () {
      return {
        dialogVisible: false,
        activeName: 'wechat',
        codeurl:'',
        menulist:[
          {
            path:'/home/activity',
            icon:'https://assets.pfotoo.com/icon/pc%E6%B4%BB%E5%8A%A8%E7%AE%A1%E7%90%86.svg',
            name:'我管理的',
            width:24,
            height:24
          },
          {
            path:'/home/reports',
            icon:'https://assets.pfotoo.com/icon/download.svg',
            name:'下载/导出',
            width:22,
            height:22,
          },
          {
            path:'/home/resultQuery/index',
            icon:'https://assets.pfotoo.com/icon/upload2.svg',
            name:'结果查询',
            width:22,
            height:22
          },
          /*
          {
            path:'/home/create',
            icon:'https://qn002.pfotoo.com/icon/pc设置.svg',
            name:'征稿设置',
            width:22,
            height:23
          },
          {
            path:'/home/setting',
            icon:'https://assets.pfotoo.com/icon/pc设置.svg',
            name:'账号设置',
            width:22,
            height:23
          }
          */
          {
            path:'/home/downhis',
            icon:'https://assets.pfotoo.com/icon/upload2.svg',
            name:'下载记录',
            width:22,
            height:22
          },
        ]
      }
    },
    methods:{
      getlogincode(){
       this.$http({
         url:'https://pfotoo.com?s=App.User.LoginQrcode'+this.$getsign(),
         data:{},
         method:'POST',
         headers: {
           'Content-Type': 'application/x-www-form-urlencoded'
         }
       }).then((res)=>{
         console.log(res.body)
         let json=res.body;
         if(res.body.ret==200){
           this.code=json.data.code;
           this.codeurl=json.data.url;
         }
       })
     },
     tohome(){
       console.log(this.$route);
       if(this.$route.name=='draft'){
          this.$router.go(0);
       }else{
        this.$router.replace({
           path:'/home/activity/index',
        })
       }

     },
      hasTest:App.hasTestStyle,
      handleClose(done) {
        done();
      },
      handleClick(tab, event) {
        console.log(tab, event);
      }
    },
    async mounted(){
      this.codeurl=await App.System.Qrcode({
        autoColor:false,
        inHyaline:false,
        lineColor:'0,0,0',
        page:'pages/enter/enter',
        scene:'//mm',
        width:300,
        appId:'wxe15e90f50a8379b7',
      },'URL')
    },

  }
</script>

<style>
  .menu{
    position: fixed;
    left:0;
    top:0;
    width:200px;
    bottom:0;
    background: #2d3d4a;
  }
  .menu-top{
    width: 100%;
    height: 70px;
    padding-left: 25px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    cursor: pointer;
  }
  .logo {
      width: 42px;
      height: 42px;
      margin-right: 10px;
      border-radius: 50%;
  }
  .menu-top strong {
      opacity: .65;
  }
  .menu-single {
      width: 100%;
      height: 60px;
      padding-left: 30px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      opacity: .65;
      /* border-bottom: 1px solid #001a33; */
      cursor: pointer;
  }
  ._active {
    background: #1a2e3b;
    opacity: 1;
    border: none;
  }
  .menu-list{
    position: relative;
    height: calc(100vh - 90px);
  }
  .menu-single:last-child{
    position: absolute;
    bottom: 0px;
    z-index: 99999;
  }
</style>



// WEBPACK FOOTER //
// src/components/menu.vue